import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function AssetBreadcrumb({ chain }) {
  if (!chain || chain.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 10, color: "#4a5568" }}>
      {chain.map((item, idx) => (
        <span key={item.id || `${item.name}-${idx}`}>
          {idx > 0 ? " / " : ""}
          <Link to={`/assets/${item.id}`}>{item.name}</Link>
        </span>
      ))}
    </div>
  );
}

AssetBreadcrumb.propTypes = {
  chain: PropTypes.array
};
